import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button
} from '@mui/material';

const AddressDialog = ({
  open,
  onClose,
  additionalAddress,
  onInputChange
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Additional Business Address</DialogTitle>
      <DialogContent>
        <TextField
          label="Address"
          fullWidth
          margin="normal"
          value={additionalAddress.address}
          onChange={onInputChange('address')}
        />
        <TextField
          label="City"
          fullWidth
          margin="normal"
          value={additionalAddress.city}
          onChange={onInputChange('city')}
        />
        <TextField
          label="District"
          fullWidth
          margin="normal"
          value={additionalAddress.district}
          onChange={onInputChange('district')}
        />
        <TextField
          label="State"
          fullWidth
          margin="normal"
          value={additionalAddress.state}
          onChange={onInputChange('state')}
        />
        <TextField
          label="Pincode"
          fullWidth
          margin="normal"
          value={additionalAddress.pincode}
          onChange={onInputChange('pincode')}
        />
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
        >
          Save Address
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AddressDialog;